import { OktaAuthOptions } from '@okta/okta-auth-js';

type Environment = 'local' | 'staging' | 'production';

const OKTA_DOMAIN: string = 'https://homesome.okta.com';

interface ConfigVariables {
  FE_URL: string;
  API_SERVER_URL: string;
  GOOGLE_ANALYTICS_MEASUREMENT_ID: string;
  OKTA_CONFIG: OktaAuthOptions;
  AWS_S3_PRODUCT_IMAGES_BUCKET_NAME: string;
  ENV: Environment;

  FEATURE_FLAGS: {
    PROXY_URL: string;
    PROXY_SECRET: string;
    REFRESH_RATE: number; // in seconds
    FEATURES: {
      EDIT_PRODUCT: 'edit-product';
      ADD_PRODUCT: 'add-product';
    };
  };
}

const localEnvs: ConfigVariables = {
  FE_URL: 'http://localhost:3000',
  API_SERVER_URL: 'http://localhost:5000/api/products',
  GOOGLE_ANALYTICS_MEASUREMENT_ID: 'G-9X6FZX8T5Q',
  OKTA_CONFIG: {
    clientId: '0oaatvzfeEOUAEQp5696',
    issuer: `${OKTA_DOMAIN}/oauth2/default`,
    redirectUri: 'http://localhost:3000/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    postLogoutRedirectUri: 'http://localhost:3000/logout/callback'
  },
  AWS_S3_PRODUCT_IMAGES_BUCKET_NAME: 'store.admin.products',
  ENV: 'local',

  FEATURE_FLAGS: {
    PROXY_URL: 'https://unleash.stg-homesome.com/proxy',
    PROXY_SECRET: 'w^`$E4sC};F3CC]{',
    REFRESH_RATE: 60,
    FEATURES: {
      EDIT_PRODUCT: 'edit-product',
      ADD_PRODUCT: 'add-product'
    }
  }
};

const stagingEnvs: ConfigVariables = {
  FE_URL: 'https://store-admin.stg-homesome.com',
  API_SERVER_URL: 'https://store-admin-backend.stg-homesome.com/api/products',
  GOOGLE_ANALYTICS_MEASUREMENT_ID: 'G-LP8Q59Q24W',
  OKTA_CONFIG: {
    clientId: '0oab0r6e02O5jaxzi696',
    issuer: `${OKTA_DOMAIN}/oauth2/default`,
    redirectUri: 'https://store-admin.stg-homesome.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    postLogoutRedirectUri: 'https://store-admin.stg-homesome.com/logout/callback'
  },
  AWS_S3_PRODUCT_IMAGES_BUCKET_NAME: 'store.admin.products',
  ENV: 'staging',

  FEATURE_FLAGS: {
    PROXY_URL: 'https://unleash.stg-homesome.com/proxy',
    PROXY_SECRET: 'w^`$E4sC};F3CC]{',
    REFRESH_RATE: 60,
    FEATURES: {
      EDIT_PRODUCT: 'edit-product',
      ADD_PRODUCT: 'add-product'
    }
  }
};

const productionEnvs: ConfigVariables = {
  FE_URL: 'https://store-admin.homesome.com',
  API_SERVER_URL: 'https://store-admin-backend.homesome.com/api/products',
  GOOGLE_ANALYTICS_MEASUREMENT_ID: 'G-95E8DZXSRB',
  OKTA_CONFIG: {
    clientId: '0oab0oretNSYcJErD696',
    issuer: `${OKTA_DOMAIN}/oauth2/default`,
    redirectUri: 'https://store-admin.homesome.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    postLogoutRedirectUri: 'https://store-admin.homesome.com/logout/callback'
  },
  AWS_S3_PRODUCT_IMAGES_BUCKET_NAME: 'www.gethomesome.com',
  ENV: 'production',

  FEATURE_FLAGS: {
    PROXY_URL: 'https://unleash.homesome.com/proxy',
    PROXY_SECRET: '2W2#?DDDj$tC7:eS+',
    REFRESH_RATE: 60,
    FEATURES: {
      EDIT_PRODUCT: 'edit-product',
      ADD_PRODUCT: 'add-product'
    }
  }
};

const environmentConfigs: Record<Environment, ConfigVariables> = {
  local: localEnvs,
  staging: stagingEnvs,
  production: productionEnvs
};

const hostname: string = document.location.hostname;
let selectedEnv: Environment;

if (hostname.includes('localhost')) {
  selectedEnv = 'local';
} else if (hostname.includes('stg')) {
  selectedEnv = 'staging';
} else {
  selectedEnv = 'production';
}

export default environmentConfigs[selectedEnv];
